import { useCallback, useEffect, useState } from "react";
import { fetchCount, fetchInvite, fetchShare, fetchStoreLinks, fetchStories } from "../lib/api";
import { Hero } from "../components/woven/Hero";
import { SoundFamiliar } from "../components/woven/SoundFamiliar";
import { WhatIsWoven } from "../components/woven/WhatIsWoven";
import { FounderNote } from "../components/woven/FounderNote";
import { HowItWorks } from "../components/woven/HowItWorks";
import { Waitlist } from "../components/woven/Waitlist";
import { FamilyStories } from "../components/woven/FamilyStories";
import { Footer } from "../components/woven/Footer";

export default function Landing() {
  const [count, setCount] = useState(0);
  const [invite, setInvite] = useState(null);
  const [storeLinks, setStoreLinks] = useState({});
  const [referral, setReferral] = useState(null);
  const [stories, setStories] = useState([]);

  const refreshCount = useCallback(() => {
    fetchCount().then(({ data }) => setCount(data.count)).catch(() => setCount(0));
  }, []);

  useEffect(() => {
    refreshCount();
    fetchStoreLinks().then(({ data }) => setStoreLinks(data)).catch(() => {});
    fetchStories().then(({ data }) => setStories(data)).catch(() => {});
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) fetchShare(ref).then(({ data }) => setReferral({ token: ref, name: data.family_name })).catch(() => {});
    const token = new URLSearchParams(window.location.search).get("invite");
    if (token) fetchInvite(token).then(({ data }) => setInvite({ token, name: data.inviter_name })).catch(() => {});
  }, [refreshCount]);

  return (
    <div data-testid="landing-page" className="overflow-x-hidden">
      <main>
        <Hero count={count} storeLinks={storeLinks} />
        <SoundFamiliar />
        <WhatIsWoven />
        <FounderNote />
        <HowItWorks />
        <FamilyStories stories={stories} />
        <Waitlist count={count} onJoined={refreshCount} invite={invite} referral={referral} />
      </main>
      <Footer />
    </div>
  );
}
